import { useEffect, useState } from 'react';
import { useServices } from 'core/common/hooks';
import { loadAnimationData } from './animationDataCache';

type LoadedAnimation = {
  url: string;
  data: object;
};

export const useAnimationData = (url: string) => {
  const { contentManagerService } = useServices();
  const [loadedAnimation, setLoadedAnimation] = useState<LoadedAnimation | null>(null);

  useEffect(() => {
    if (!url) return;

    const loadAnimation = async () => {
      const data = await loadAnimationData(contentManagerService, url);

      if (data) {
        setLoadedAnimation({ url, data });
      }
    };

    loadAnimation();
  }, [contentManagerService, url]);

  return loadedAnimation?.url === url ? loadedAnimation.data : null;
};
